import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ChevronRight } from 'lucide-vue-next';
    import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { useVoucherStore } from '@/stores/voucher';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkAssignProjectVouchers',
  props: {
    selectedVouchers: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const props = __props;

    const assignVouchers = () => {
        voucherStore.setValidVouchers(props.selectedVouchers);
        voucherStore.toggleOpen('project', true);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenuItem), { onClick: assignVouchers }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('vouchers.select.assign_project')) + " ", 1),
      _createVNode(_unref(ChevronRight), { class: "text-primary" })
    ]),
    _: 1
  }))
}
}

})